import React from 'react'
import { Text, csx } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'

export type PackageTitleProps = {
  packageNumber: number
}

export const PackageTitle = ({ packageNumber }: PackageTitleProps) => (
  <Text variant="pageTitle" className={csx({ marginTop: '$space-4' })}>
    <FormattedMessage id="checkout.shipping-method-selection.title" />
    {` ${packageNumber}`}
  </Text>
)
